module.exports = "<div id=\"{{this.chartID}}\"></div>\n"